/*
 * divider
 */
import * as SeparatorPrimitive from "@radix-ui/react-separator"
import { cn } from "../utils"
import { forwardRef } from "react"

export type DividerProps = SeparatorPrimitive.SeparatorProps & {
	orientation?: "horizontal" | "vertical"
	decorative?: boolean
	className?: string
}

const Divider = forwardRef<
	React.ElementRef<typeof SeparatorPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(
	(
		{ className, orientation = "horizontal", decorative = true, ...props },
		ref,
	) => (
		<SeparatorPrimitive.Root
			ref={ref}
			decorative={decorative}
			orientation={orientation}
			className={cn(
				"bg-border shrink-0",
				orientation === "horizontal" ? "min-h-px w-full" : "h-full min-w-px",
				className,
			)}
			{...props}
		/>
	),
)
Divider.displayName = "Divider"

export { Divider }
